import { buildPathname, parsePathname } from "../../constants/routes.js";

export function readUrlLocation(pathname = window.location.pathname) {
  return parsePathname(pathname);
}

export function pushAppUrl(location, { replace = false } = {}) {
  const nextPath = buildPathname(location);
  const currentPath = window.location.pathname;

  if (nextPath === currentPath) return;

  const state = { ...location };
  if (replace) {
    window.history.replaceState(state, "", nextPath);
  } else {
    window.history.pushState(state, "", nextPath);
  }
}

export function replaceAppUrl(location) {
  pushAppUrl(location, { replace: true });
}
